import React, { Component } from 'react';
import './blog.scss';
import BlogCard from '../../components/blog-card/blog-card';
import $ from 'jquery';
import 'jquery-match-height';

class Blog extends Component {

  componentDidMount() {
    window.scrollTo(0, 0);
    var options = {
      byRow: false,
    }
    $('.card-title').matchHeight(options);
  }

  render() {
    return (
      <div className="blog">
        <div className="header">
          <div className="title-container">
            <h1 className="title" data-aos="fade-down" data-aos-duration="1000">We find, post and write articles for you!</h1>
            <h3 className="subtitle" data-aos="fade-up" data-aos-delay="1000" data-aos-duration="1000">We help you stay up-to-date with the latest tech news and trends from around the industry.</h3>
          </div>
        </div>
        <div className="blog-cards">
          <BlogCard
            imgsrc={require('../../assets/office.png')}
            cardTitle="How To Build Food Delivery App To Boost Your Business"
            cardText="This is the line where everyone writes something in line of ‘We’re pleased to announce our new website launch of WebMob Technologies today’. Well, believe us we also thought 100s of different ways and…"
            category="Designing, Development, Marketing"
            datePosted="Wednesday, July 5th 2017"
            buttonColor="red"
            />
          <BlogCard
            imgsrc={require('../../assets/computer-background.jpg')}
            cardTitle="WebMob Technologies Featured "
            cardText="When the software development was new it consisted a defined process only for programmers to write some code and meet the client’s agenda. Nowadays, systems are big and complex in terms of analysis, s…"
            category="Marketing"
            datePosted="Wednesday, July 5th 2017"
            buttonColor="blue"
            />
          <BlogCard
            imgsrc={require('../../assets/computer-background.jpg')}
            cardTitle="Re-branding of WebMob Technologies!"
            cardText="So even after being an entrepreneur he must be operating the software firm remotely from his home at 221B Baker Street. He might have invented a way of using MAC laptop with Linux operating system ins…"
            category="Designing, Development, Marketing"
            datePosted="Wednesday, July 5th 2017"
            buttonColor="orange"
            />
          <BlogCard
            imgsrc={require('../../assets/office.png')}
            cardTitle="What is SDLC? How can it work for you?"
            cardText="Once you’re done with your mobile application for the next big thing with the designing, coding and testing; time comes to make it live. Time to submit the application on respective store; for Android…"
            category="Analysis, IT Management, R&D"
            datePosted="Wednesday, July 5th 2017"
            buttonColor="green"
            />
        </div>
      </div>
    );
  }
}

export default Blog;



// WEBPACK FOOTER //
// ./src/pages/blog/blog.js